export default {
  template: `
    <span v-if="show" class="status-pill" :class="statusVariant" v-b-tooltip.viewport="tooltipText">
      <svg v-if="statusIcon" viewBox="0 0 24 24" class="icon-xs-2 ml-05"><use :xlink:href="'#icon-' + statusIcon"></use></svg>
      {{ displayText }}
    </span>
  `,
  data() {
    return {
      statusVariant: '',
      displayText: 'Unknown',
      show: false,
      statusIcon: '',
      tooltipText: ''
    }
  },
  computed: {
    status() {
      return this.params.value ? this.params.value.toLowerCase() : 'active';
    }
  },
  methods: {
    setBadgeStyle() {
      // Handle case where subscription_status field is missing entirely
      // if (!this.params.value || this.params.value === undefined || this.params.value === null) {
      //   this.show = false;
      //   return;
      // }
      
      // We have a subscription status, so render it
      this.show = true;
            
      switch (this.status) {
        case 'active':
          this.statusVariant = 'status-pill-success';
          this.statusIcon = 'status-success';
          this.displayText = 'Active';
          this.tooltipText = 'This member can access your hub.';
          break;
        case 'past_due':
          this.statusIcon = 'clock';
          this.displayText = 'Past Due';
          this.tooltipText = 'Member’s last payment failed. We’ll retry soon.';
          break;
        case 'canceled':
          this.statusVariant = 'status-pill-danger';
          this.statusIcon = 'status-disabled';
          this.displayText = 'Canceled';
          this.tooltipText = 'Subscription ended. Member will no longer be billed.';
          break;
        case 'unpaid':
          this.statusVariant = 'status-pill-danger';
          this.statusIcon = 'status-error';
          this.displayText = 'Unpaid';
          this.tooltipText = 'Final payment failed. Subscription is now inactive.';
          break;
        case 'incomplete':
          this.statusVariant = 'status-pill-warning';
          this.statusIcon = 'minus-circle';
          this.displayText = 'Incomplete';
          this.tooltipText = 'Signup process wasn’t finished. No access.';
          break;
        case 'incomplete_expired':
          this.statusIcon = 'clock-reverse';
          this.displayText = 'Expired';
          this.tooltipText = 'Member didn’t complete first payment in time.';
          break;
        case 'paused':
          this.statusIcon = 'pause-circle';
          this.displayText = 'Paused';
          this.tooltipText = 'Member’s subscription is paused. No charges for now.';
          break;
        case 'pending':
          this.statusIcon = 'clock';
          this.displayText = 'Pending';
          this.tooltipText = 'Invited or lead who hasn’t completed registration. No hub access.';
          break;
        case 'trialing':
          this.statusVariant = 'status-pill-success';
          this.statusIcon = 'clock';
          this.displayText = 'Trialing';
          this.tooltipText = 'Member is in a free trial. Billing will start when it ends.';
          break;
        case 'no-access':
          this.statusVariant = 'status-pill-warning';
          this.statusIcon = 'minus-circle';
          this.displayText = 'Incomplete';
          this.tooltipText = 'Signup process wasn’t finished. No access.';
          break;
        default:
          this.statusVariant = '';
          this.statusIcon = '';
      }
    }
  },
  beforeMount() {
    this.setBadgeStyle();
  }
};
